import { render, staticRenderFns } from "./firstTarget.vue?vue&type=template&id=6c15565a&scoped=true&"
import script from "./firstTarget.vue?vue&type=script&lang=js&"
export * from "./firstTarget.vue?vue&type=script&lang=js&"
import style0 from "./firstTarget.vue?vue&type=style&index=0&id=6c15565a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c15565a",
  null
  
)

export default component.exports